import React, { FC } from "react";
import bannerImg from "ui-library/assets/images/banner-prihlasenie.svg";
import { SectionBanner } from "ui-library/modules";

export const LoadingLayout: FC = () => <SectionBanner imageUrl={bannerImg} />;
